<template>
  <v-autocomplete
    v-model="entity"
    :items="listEntitiesSelect"
    :label="$gettext(label)"
    :disabled="disabled"
    :error-messages="errorMessages"
    return-object
    :outlined="isOutlined"
    :dense="isDense"
    :hide-details="hideDetails"
    clearable
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { difference } from 'lodash'

export default {
  name: 'AutoCompleteLancamentoFIa',
  // props: ['typesEntities', 'inativos'],
  props: {
    entityProps: {
      type: Object,
      default: () => {}
    },
    typesEntities: {
      type: Array,
      default: () => []
    },

    entityId: {
      type: Number,
      default: null
    },

    listaItensSelectProps: {
      type: Object,
      default: () => {}
    },

    label: {
      type: String,
      default: 'Terminal'
    },

    parentId: {
      type: Number,
      default: null
    },

    stop: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errorMessages: {
      type: Array,
      default: () => []
    },

    isDense: {
      type: Boolean,
      default: true
    },

    isOutlined: {
      type: Boolean,
      default: false
    },

    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoadingAutoComplete: false,
    modelAutoComplete: null,
    searchText: null,
    loading: false,
    entity: null,
    listEntitiesSelect: []
  }),

  mounted () {
    if (!this.stop) {
      this.getEntities(this.typesEntities, {'Entities:deleted_>=': this.inativos ? '1970-01-01' : undefined})
    }

    this.entity = this.entityId
  },

  watch: {
    listaItensSelect (val) {
      this.$emit('update:listaItensSelectProps', val)
    },

    entity (val) {
      this.$emit('update:entityProps', val)
    },

    entityProps (val) {
      this.entity = val
    },

    entityId (val) {
      this.entity = val
      this.getEntities(this.typesEntities)
    },

    parentId () {
      this.listEntitiesSelect = []
      this.getEntities(this.typesEntities, {'Entities:deleted_>=': this.inativos ? '1970-01-01' : undefined})
    },

    typesEntities (val, valold) {
      let differeArray = difference(val, valold)

      if (differeArray.length)
        this.getEntities(val, {'Entities:deleted_>=': this.inativos ? '1970-01-01' : undefined})
    }
  },

  computed: {
    ...mapGetters('entities', ['listaItensSelect'])
  },

  methods: {
    ...mapActions('entities', ['getListDRE']),

    async getEntities (types, filter = {}) {
      this.isLoadingAutoComplete = true
      
      const filterParentId = {
        "Entities:parentId_=": this.parentId ? this.parentId : undefined,
      }
      return await this.getListDRE({
          _filter: { 'entityTypeId_In': types.toString(), ...filter, ...filterParentId },
          pageSize: this.$store.getters.ItensPaginacao,
          order: {'cod::int': 'ASC'}
      }).then(e => {
        this.listEntitiesSelect = e
      })
      .finally(() => this.isLoadingAutoComplete = false)
    }
  }
}
</script>